export default function ProjectsPage() {
    return (<h2>Projects page</h2>)
}